













import { Component, Prop, Vue } from 'vue-property-decorator'
import { Room } from '@/class/room'
import { RoomMember } from '@/class/roomMember'
import GlobalMenu from '@/components/SideMenu/GlobalMenu.vue'
import GameMenu from '@/components/SideMenu/GameMenu.vue'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'

@Component({
  components: {
    GlobalMenu,
    GameMenu,
    BtnSquare
  }
})
export default class Menu extends Vue {
  @Prop() room!: Room;
  @Prop() self!: RoomMember;
  @Prop() isGallary!: boolean;
}
